<template>
  <div :class="$style.root">
    <img :class="$style.icon" src="./icon.png" /><slot /><img
      :class="$style.icon"
      src="./icon.png"
    />
  </div>
</template>

<script>
export default {
  name: "TitleStyle1"
};
</script>

<style lang="scss" module>
$page-width: 375;
@import "~style/tool";

.root {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  font-size: rem(18);
  color: rgba(51, 51, 51, 1);
}

.icon {
  width: rem(11);
  height: rem(8);
}

.icon:first-child {
  margin-right: rem(8);
}
.icon:last-child {
  margin-left: rem(8);
}
</style>
